import styles from './AppRadio.module.scss'

interface AppRadioOption<T extends string> {
  label: string
  value: T
}

interface AppRadioProps<T extends string> {
  title?: string
  name: string
  value?: T
  options: AppRadioOption<T>[]
  onChange: (value: T) => void
}

export const AppRadio = <T extends string>({
  title,
  name,
  value,
  options,
  onChange,
}: AppRadioProps<T>) => {
  return (
    <div className={styles.container}>
      {title && <div className={styles.label}>{title}</div>}

      <div className={styles.field}>
        {options.map(option => (
          <label key={option.value} className={styles.option}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
            />

            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
